var render, staticRenderFns
import script from "./EmphasizedSelect.vue?vue&type=script&lang=ts&"
export * from "./EmphasizedSelect.vue?vue&type=script&lang=ts&"
import style0 from "./EmphasizedSelect.vue?vue&type=style&index=0&id=2b171fb7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b171fb7",
  null
  
)

export default component.exports